import http from '@/services/rest/rest.service';
import { ILoginLog } from '@/entities/logs/login-log.interface';
import { IPaging } from '@/entities/paging.interface';
import { IGetLoginLogs } from '@/entities';
import {
    ICompanyFeeModel,
    ICompanyFeeUpdateModel
} from '@/entities/company-fees';

export default {
    list(siteId: number, typeId: number): Promise<ICompanyFeeModel[]> {
        return http.get(`companies/fees?siteId=${siteId}&typeId=${typeId}`);
    },
    update(model: ICompanyFeeUpdateModel) {
        return http.post(`companies/fees`, model);
    }
};
